import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './style.scss';

interface UserAgreementProps {
  payPhone?: boolean;
  extraText?: string | null;
}

const GoodPayUserAgreement: FC<UserAgreementProps> = ({
  payPhone,
  extraText
}) => {
  const { t } = useTranslation();
  return (
    <div className="user-agreement">
      <>
        &nbsp;
        <p className="user-agreement__text">
          {t('common:alert_share_cart_details')}
          &nbsp;
          <a
            target="_blank"
            rel="noreferrer"
            href="https://newpay.kz/page-docs.html?tab=3"
            className="user-agreement__link"
          >
            {t('common:alert_share_cart_details_label')}
            &nbsp;
          </a>
          &nbsp;
        </p>
        &nbsp;
      </>

      <p className="user-agreement__text">
        {t('common:take_btn')} {t('common:confirm')}, {t('common:agree')}
        &nbsp;
        {!payPhone && (
          <a
            href="/goodpay-public-ofert.pdf"
            download
            className="user-agreement__link"
          >
            {t('common:private_offer')}
          </a>
        )}
        <a
          href="/goodpay-politics.pdf"
          download
          className="user-agreement__link"
        >
          {t('common:private_policy')}
        </a>
        &nbsp;
      </p>

      {!payPhone && (
        <>
          &nbsp;
          <p className="user-agreement__text">
            {t('common:alert_share_cart_details')}
            &nbsp;
            <a
              target="_blank"
              rel="noreferrer"
              href="https://newpay.kz/page-docs.html?tab=3"
              className="user-agreement__link"
            >
              {t('common:alert_share_cart_details_label')}
              &nbsp;
            </a>
            &nbsp;
          </p>
        </>
      )}

      {extraText && (
        <p className="user-agreement__text" style={{ marginTop: '10px' }}>
          {extraText}
        </p>
      )}
    </div>
  );
};

export default GoodPayUserAgreement;
